(function () {
    "use strict";

    // @ngInject
    function NetworkConnectionsControllerCtor($scope, $injector, UsersManager, AnalyticsService, CompanyService, _, NetworkManager,
                                              $filter, ModelFactory, NetworkService, $translate, $stateParams, ContactsManager, $q,
                                              UserService, $timeout, PopupMessageService, ModalService, UiPersistenceService, ngToast, UIUtils, SuggestionsService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkConnectionsController';
        AnalyticsService.trackPageView(this, 'network connections');

        this.CompanyService = CompanyService;
        this.UsersManager = UsersManager;
        this.AnalyticsService = AnalyticsService;
        this.NetworkManager = NetworkManager;
        this.ModelFactory = ModelFactory;
        this.NetworkService = NetworkService;
        this.$translate = $translate;
        this._ = _;
        this.$q = $q;
        this.UserService = UserService;
        this.PopupMessageService = PopupMessageService;
        this.ModalService = ModalService;
        this.$timeout = $timeout;

        this.connections = this.ModelFactory.newNetworkUsersCollection();
        this.connections_pendding = this.ModelFactory.newNetworkUsersCollection();
        this.contacts = this.ModelFactory.newContactsCollection();
        this.UIUtils = UIUtils;

        this.connectionsPage = 1;
        this.connectionsRequestsPage = 1;
        this.contactsTotal;
        this.contactsTotalLoading = true;
        this.vendorUsers = [];
        this.suggestedSearchUsers = [];
        this.ContactsManager = ContactsManager;
        this.currNetworkUser = this.NetworkManager.getNetworkCurrUser();
        this.ngToast = ngToast;

        this.suggestedContacts = [];
        this.suggestedSearchContacts = [];
        this.UiPersistenceService = UiPersistenceService;

        this.peopleSuggestionsBlacklist = UiPersistenceService.getUiPersistence(UiPersistenceService.keys.peopleSuggestionsBlacklist,
            {googleEmails: []});

        var googleSuggestionsPromise = this.getGoogleContactSuggestions();

        googleSuggestionsPromise
            .then(function success(googleSuggestions) {
                this.suggestedContacts = this._.reject(googleSuggestions, function (contact) {
                    return (this._.contains(this.peopleSuggestionsBlacklist.googleEmails, contact.user.email) ||
                        (!!contact.user && !!(contact.user_id || contact.user._id) && contact.user.system_user_type === 'client'));
                }.bind(this));
                this.suggestedContacts = this._.shuffle(this.suggestedContacts);
            }.bind(this))
            .finally(function suggestionFinally() {
                this.loadingSuggestions = false;
            }.bind(this));

        var tempSearchText = '',
            searchTimeout;

        $scope.$watch('networkConnectionsVm.searchTxt', function (val) {
            if (searchTimeout) {
                $timeout.cancel(searchTimeout);
            }

            tempSearchText = val;
            searchTimeout = $timeout(function () {
                this.suggestedSearchContacts.length = 0;
                this.searchInGoogleContacts(tempSearchText);
            }.bind(this), 800); // delay 800 ms
        }.bind(this));

        this.loadingVendorUsers = true;
        this.canLoadMore = false;
        this.getConnectionsPromise = this.NetworkManager.getConnections(this.connections, this.currNetworkUser._id, this.connectionsPage);
        this.getConnectionsRequestsPromise = this.NetworkManager.getConnections(this.connections_pendding, this.currNetworkUser._id, this.connectionsRequestsPage, true);
        this.NetworkManager.getConnections(this.connections_pendding, this.currNetworkUser._id, this.connectionsRequestsPage, true);

        this.getContactsCount = function getContactsCount() {
            this.ContactsManager.getContactsCount({vendors_only: true}).then(function (res) {
                if (res.data && res.data.count) {
                    this.contactsTotal = res.data.count;
                } else {
                    this.contactsTotal = 0;
                }
            }.bind(this)).catch(function () {
                this.contactsTotal = '?';
            }.bind(this)).finally(function () {
                this.contactsTotalLoading = false;
            }.bind(this));
        }.bind(this);

        this.getContactsCount();

        this.connections_title = 'Connections';

        this.getConnectionsRequestsPromise.then(function (res) {
            this.connectionRequestCount = res.totalCollectionItems;

        }.bind(this));

        this.getConnectionsPromise.then(function (res) {
            // we use the seperate promise because the this.currNetworkUser.network.connections_count is cached in storage meaning the count does not get updated..
            // and the only way to get the totalCollectionItems is by promise and not event.
            this.connections_title = this.simplePluralize('Connection', res.totalCollectionItems);
        }.bind(this));
        this.register(this.connections, 'success', function (successType, respStatus, respIsComplete) {
            this.loadingConnections = false;
            this.canLoadMore = !respIsComplete;

            // this.connections_title = this.simplePluralize('Connection', this.currNetworkUser.network.connections_count);


        }.bind(this));

        this.register(this.connections_pendding, 'success', function (successType, respStatus, respIsComplete) {
            this.loadingConnectionRequests = false;
            this.canLoadMoreRequests = !respIsComplete;
            this.connections_awaiting_response = $filter('filter')(this.connections_pendding, {network: {connection_data: {connection_status: 'needs_response'}}});
            // this.connections_requested = $filter('filter')(this.connections_pendding, {network: {connection_data: {connection_status: 'requested'}}});
            this.connections_connected_requested = $filter('filter')(this.connections_pendding, function (element) {
                var status = element.network.connection_data.connection_status;
                return status === 'requested';
            });

            if (this.connections_connected_requested.length) {
                this.pending_connections_title = ' (' + this.connections_connected_requested.length + ' pending)';
            }

        }.bind(this));

        this.fetchingSuggestions = true;
        this.canLoadMoreSuggestions = true;
        this.suggestions = this.NetworkManager.getConnectionSuggestions(null, 20, 30);
        this.register(this.suggestions, 'success', function (successType, respStatus, respIsComplete) {
            this.fetchingSuggestions = false;
            if (this.suggestions && this.suggestions.length > 0) {
                AnalyticsService.trackPageView(this, 'network connections suggestions ', {howManySuggestions: this.suggestions.length});
            }

        }.bind(this));
        this.register(this.suggestions, 'error', function error(errorType) {
            this.fetchingSuggestions = false;
        }.bind(this));


        // copied over from NetworkDirectoryController
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.currUserId = this.currUser ? this.currUser._id : undefined;

        this.searchTxt = '';
        this.loadingVendorUsers = true;

        this.networkUsers = this.NetworkManager.getNetworkUsersCollection();
        this.suggestedSearchUsers = ModelFactory.newNetworkUsersCollection();

        this.vendorTypes = this.CompanyService.getCompanyTypesEnum();

        this.vendorTypesFilterable = this.vendorTypes.map(function (type) {
            type.textLabel = this.$translate.instant(type.text);
            return type;
        }.bind(this));

        this.filteredVendorTypes = [];
        // this.hasFilterQueue = false;
        this.activeFilters = {};
        this.filteredState = null;
        this.filteredCity = null;

        this.hideInactiveFilterButtons = false;
        this.hideMoreFilters = true;
        this.firstPage = 1;
        this.page = this.firstPage;


        // Init pagination controls
        this.maxPages = 1;
        this.startResultsPage = 1;
        this.endResultsPage = 1;
        this.numPagesToShow = 5;
        this.numResultsPerPage = 25;
        this.resultsPage = 1;
        this.serverSidePaging = true;

        this.hasMoreNetworkUsersToShow = false;
        this.searchMembers();

        _.each(this.vendorTypes, function (item) {
            this.activeFilters[item.key] = false;
        }.bind(this));

        // end copy

        this.locationIsCity = null;
        this.filterTypesInput = '';
        this.filterTypesInputFocused = false;
        this.filterTypesLabelText = '';

        this.showFiltersMobile = false;

        if ($stateParams.googleIntegrationCreated) {
            this.openGoogleContactsModal();
        }

        var onGoogleContactClicked = this.connectToAGoogleAccount.bind(this);

        this.UserService.on('syncGoogleContactClicked', onGoogleContactClicked);

        $scope.$on('$destroy', function () {
            this.UserService.off('syncGoogleContactClicked', onGoogleContactClicked);
        }.bind(this));

        this.showGoogleConnect = !this.currUser.isGoogleIntegrationActive('contacts');

    }

    Controllers.NetworkConnectionsController = Class(Controllers.BaseController, {

        constructor: NetworkConnectionsControllerCtor,

        openGoogleContactsModal: function openGoogleContactsModal() {
            this.ModalService.openGoogleContactsModal(this.addSuggested.bind(this), 'Connect', true, true, 'connections', 'add connection');
        },

        getConnectionStatus: function getConnectionStatus() {
            var status = null;
            if (this.network.connection_data && this.network.connection_data.connection_status === "requested") {
                status = this.network.connection_data.connection_status;

            }
            return status;
        },

        loadMore: function loadMore() {
            this.loadingConnections = true;
            this.connectionsPage++;
            this.NetworkManager.getConnections(this.connections, this.currNetworkUser._id, this.connectionsPage);
        },

        loadMoreRequests: function loadMoreRequests() {
            this.connectionsRequestsPage++;
            this.NetworkManager.getConnections(this.connections_pendding, this.currNetworkUser._id, this.connectionsRequestsPage, true);
            this.loadingConnectionRequests = true;
        },

        simplePluralize: function simplePluralize(str, num) {
            return num == 1 ? '1 ' + str : num + ' ' + str + 's';
        },


        // copied over from NetworkDirectoryController
        toggleFilterByType: function toggleFilterByType(key) {
            this.loadingVendorUsers = true;
            var index = this.filteredVendorTypes.indexOf(key);
            if (index > -1) {
                this.filteredVendorTypes.splice(index, 1);
            } else {
                this.filteredVendorTypes.push(key);
            }

            this.activeFilters[key] = !this.activeFilters[key]

            if (this.activeFilters[key]) {
                this.hideInactiveFilterButtons = true;
            } else if (this.filteredVendorTypes.length === 0) {
                this.hideInactiveFilterButtons = false;
            }

            // if (!this.hasFilterQueue) {
            this.searchMembers();
            // }
        },

        clearFilteredTypes: function clearFilteredTypes() {
            this.filteredVendorTypes = [];
            this._.each(this.vendorTypes, function (item) {
                this.activeFilters[item.key] = false;
            }.bind(this));

            this.handleCloseTypes();
            this.searchMembers();
        },

        getSearchResults: function getSearchResults() {
            if (this.searchTxt.length === 0) {
                this.clearSearch();
            } else if (this.searchTxt.length > 2) {
                this.searchMembers();
            }
        },

        filterActive: function filterActive(key) {

            this.loadingVendorUsers = true;
            return (this.filteredVendorTypes.indexOf(key) > -1);

        },

        searchMembers: function searchMembers(page) {
            // If no page is set, pull the first page results by default
            var firstPage = 1;
            if (!angular.isDefined(page)) {
                page = firstPage;
                this.maxPages = 0;
            } else if (page === this.resultsPage) {
                return;  // Ignore clicks for the same page
            }

            // Ignore Next/Prev if on first or last page
            if (page < firstPage || (angular.isDefined(this.maxPages) && this.maxPages > 0 && page > this.maxPages)) {
                return;
            }

            this.loadingVendorUsers = true;
            this.showSearchSuggestions = false;


            this.NetworkManager.listNetworkUsers(
                page,
                this.filteredVendorTypes,
                this.filteredState,
                this.filteredCity,
                this.searchTxt,
                this.numResultsPerPage,
                this.networkUsers).then(function (res) {

                this.total_count = res.data.total_count;
                this.loadingVendorUsers = false;
                this.resultsPage = page;

                // Set pagination information
                this.startResultsPage = Math.max(page - parseInt(this.numPagesToShow / 2), 1);
                this.maxPages = Math.ceil(parseInt(this.total_count) / this.numResultsPerPage);
                this.endResultsPage = Math.min(this.startResultsPage + this.numPagesToShow - 1, this.maxPages);
                if (this.endResultsPage === this.maxPages && (this.endResultsPage - this.startResultsPage) < this.numPagesToShow) {
                    this.startResultsPage = Math.max(this.endResultsPage - this.numPagesToShow + 1, 1);
                }
            }.bind(this));
        },

        clearSearch: function clearSearch() {
            var analyticsArgs = {
                searchText: this.searchTxt
            };
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_clear_search_text, analyticsArgs);

            this.searchTxt = '';
            this.searchMembers();
        },

        vendorTypeLabel: function vendorTypeLabel(type) {
            for (var i = 0; i < this.vendorTypes.length; i++) {
                if (this.vendorTypes[i].key === type) {
                    return this.vendorTypes[i].text;
                }
            }
        },

        clearFilteredLocation: function clearFilteredLocation() {
            this.filterLocationInput = null;
            this.filteredCity = null;
            this.filteredState = null;
            this.locationIsCity = null;
            this.searchMembers();
        },

        openNetworkInviteUsers: function openNetworkInviteUsers() {
            this.NetworkService.inviteUser().then(
                function success(user) {
                    var safeString = this.UIUtils.sanitize(user.full_name);

                    this.$timeout(function () {
                        this.ngToast.create({
                            content: '<span class="icon icon-hb-nx-participants"></span>' + safeString + ' added successfully!',
                            className: 'success',
                            dismissOnTimeout: true,
                            dismissButton: true
                        });
                    }.bind(this), 1000);
                }.bind(this));
        },

        updateLocation: function updateLocation(geocodeResult) {
            angular.forEach(geocodeResult.address_components, function (addr_component) {
                if (addr_component.types[0] === 'locality') {
                    this.filterLocationInput = addr_component.long_name;
                    this.filteredCity = this.filterLocationInput;
                    this.locationIsCity = true;
                } else if (addr_component.types[0] === 'administrative_area_level_1') {
                    if (!this.locationIsCity) {
                        this.filterLocationInput = addr_component.long_name;
                    }
                    this.filteredState = addr_component.short_name;
                    this.locationIsCity = false;
                }

                this.searchMembers();
            }.bind(this));
        },

        handleSearchSubmit: function handleSearchSubmit() {
            this.searchMembers();
        },

        resetSearch: function resetSearch() {
            this.clearSearch();
            this.clearFilteredLocation();
            this.clearFilteredTypes();
        },

        showResults: function showResults() {
            return this.isFilterActive() ||
                (this.searchTxt && this.searchTxt.length);
        },

        isFilterActive: function isFilterActive() {
            return (this.filteredVendorTypes && this.filteredVendorTypes.length) ||
                (this.filteredState && this.filteredState.length) ||
                (this.filteredCity && this.filteredCity.length);
        },

        handleCloseTypes: function handleCloseTypes() {
            this.filterTypesInputFocused = false;

            this.filterTypesLabelText = this.vendorTypes.map(function (type) {
                if (this.filteredVendorTypes.indexOf(type.key) > -1) {
                    return this.$translate.instant(type.text);
                }
            }.bind(this)).filter(function (elem) {
                return Boolean(elem);
            }).join(', ');

            this.filterTypesInput = this.filterTypesLabelText;
            angular.element('.js-types-list')[0].scrollTop = 0;
        },

        handleFocusFilterTypesInput: function handleFocusFilterTypesInput() {
            this.filterTypesInputFocused = true;
            this.filterTypesInput = '';
        },

        handleClickOpenFiltersMobile: function handleClickOpenFiltersMobile() {
            this.showFiltersMobile = true;
            angular.element('body')[0].style.overflow = 'hidden';
        },

        handleClickCloseFiltersMobile: function handleClickCloseFiltersMobile() {
            this.showFiltersMobile = false;
            angular.element('body')[0].style.overflow = 'auto';
        },

        onAddGoogleSuggestionClicked: function onAddGoogleSuggestionClicked(contact) {
            if (!contact.userClicked) {
                contact.userClicked = true;
                if ((contact.user_id || contact.user._id) &&
                    contact.user.system_user_type === 'client' || contact.user.system_user_type === 'vendor') {
                    contact.typeChosen = true;
                    this.addSuggested(contact);
                }
            }
        },

        addSuggested: function addSuggested(contact) {
            if (contact.user.system_user_type !== 'vendor' && contact.user.system_user_type !== 'client') {
                return;
            }
            var self = this;

            var trackingArgs = {
                email: contact.user.email,
                type: contact.user.system_user_type,
                from: 'google'
            };

            var index;

            if (this.currNetworkUser.isGoogleIntegrationActive('contacts')) {
                // self.replaceSuggested(contact);
                // index = self.suggestedSearchContacts.indexOf(contact);
                // self.suggestedSearchContacts.splice(index, 1);
            } else {
                index = self.suggestedContacts.indexOf(contact);
                self.suggestedContacts.splice(index, 1);

                index = self.suggestedSearchContacts.indexOf(contact);
                self.suggestedSearchContacts.splice(index, 1);
            }

            if (contact.user.source === 'graph_db') {
                trackingArgs.from = 'graph_db';
                trackingArgs.email = contact.user.email;
            }

            this.ContactsManager.saveJSONContact(contact).then(function success(resp) {
                contact.added = true;
                contact._id = resp.data._id;
                if (contact.user && resp.data.user) {
                    contact.user._id = resp.data.user._id;
                }
                contact.user_id = resp.data.user_id;
                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.save_contact, trackingArgs);
            }, function error(xhr) {
                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.save_contact_unsuccessful, trackingArgs);
                self.handleXHRError(xhr);
            });

        },

        getGoogleContactSuggestions: function getGoogleContactSuggestions() {

            var defer = this.$q.defer();

            if (this.currNetworkUser.isGoogleIntegrationActive('contacts')) {
                this.UserService.getNextGoogleContacts(null, true)
                    .then(function success(contacts) {
                        defer.resolve(contacts);
                    }.bind(this))
                    .catch(function failure(resp) {
                        if (resp.data.error_type === 'HBGoogleTokenRevokedError' || resp.data.error_type === 'HBGoogleIntegrationError') {
                            this.UsersManager.getGoogleIntegrations();
                        }
                        defer.resolve([]);
                    }.bind(this));
            } else {
                defer.resolve([]);
            }

            return defer.promise;
        },

        handleXHRError: function handleXHRError(xhr) {
            var msg;
            if (xhr && xhr.responseJSON && xhr.responseJSON.error_message) {
                msg = xhr.responseJSON.error_message;
            } else {
                msg = 'DASHBOARD.CONTACTS.GOOGLE.GOOGLE_API._UNKNOWN_ERROR_';
            }
            this.PopupMessageService.showErrorAlert(msg);
        },

        connectToAGoogleAccount: function connectToAGoogleAccount(preferredGoogleAccountEmail) {
            if (this.currUser.isGoogleIntegrationActive('contacts')) {
                this.openGoogleContactsModal();
            }
            else {
                this.UserService.connectToAGoogleAccount(preferredGoogleAccountEmail, 'contacts');
            }
        },

        searchInGoogleContacts: function searchInGoogleContacts(searchTerm) {
            if (this.currNetworkUser.isGoogleIntegrationActive('contacts')) {
                if (!searchTerm || searchTerm === '') {
                    return;
                }

                this.UserService.searchGoogleContacts(searchTerm, null, null, true)
                    .then(function success(searchResults) {
                        this.suggestedSearchContacts = searchResults.contacts;
                    }.bind(this));
            }
        },

        suggestedVendorTypeTagClicked: function suggestedVendorTypeTagClicked(contact, type) {
            contact.user.system_user_type = type;
            contact.typeChosen = true;
            this.addSuggested(contact);
        },

        replaceSuggested: function replaceSuggested(contact) {
            var self = this;
            var index = self.suggestedContacts.indexOf(contact);
            contact.startFade = true;
            setTimeout(function theTimeout() {
                if (index > -1) {
                    self.UserService.getNextGoogleContacts(1).then(function success(contacts) {
                        if (contacts && contacts.length > 0) {
                            self.suggestedContacts[index] = contacts[0];
                        } else {
                            self.suggestedContacts.splice(index, 1);
                        }
                    });
                }
            }, 500);
        },

        hideSuggested: function hideSuggested(contact) {
            contact.hide = true;
            if (contact.user.imported_from && contact.user.imported_from.toLowerCase() === 'google') {
                if (contact.user.email) {
                    this.peopleSuggestionsBlacklist.googleEmails.push(contact.user.email);
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.peopleSuggestionsBlacklist, {googleEmails: this.peopleSuggestionsBlacklist.googleEmails});
                }
            }
        },

        fetchMoreSuggestions: function fetchMoreSuggestions() {
            if (this.canLoadMoreSuggestions && !this.fetchingSuggestions && this.suggestions.length > 0) {
                this.fetchingSuggestions = true;
                var newSuggestions = this.NetworkManager.getConnectionSuggestions(this.suggestions, 20, 30, true);
                this.registerOnce(newSuggestions, 'success', function (successType, respStatus, respIsComplete) {
                    this.fetchingSuggestions = false;
                    if (newSuggestions.length === 0) {
                        this.canLoadMoreSuggestions = false;
                    } else {
                        this.suggestions.push.apply(this.suggestions, newSuggestions);
                        if (this.suggestions.length >= 200) {
                            this.canLoadMoreSuggestions = false; //don't show more than 200
                        }
                    }

                }.bind(this));
                this.registerOnce(newSuggestions, 'error', function error(errorType) {
                    this.fetchingSuggestions = false;
                }.bind(this));
            }
        },

        onConnectionUpdate: function onConnectionUpdate(action) {
            this.contactsTotalLoading = true;
            this.getContactsCount();

            this.NetworkManager.getConnections(this.connections_pendding, this.currNetworkUser._id, this.connectionsRequestsPage, true)
                .then(function (res) {
                    this.connectionRequestCount = res.totalCollectionItems;
                }.bind(this));
        },

        togglePreferredContact: function togglePreferredContact(contact) {
            this.ContactsManager.updatePreferredVendorContact(contact, !contact.is_preferred)
                .then(function success(resp) {
                    contact.is_preferred = resp.data.is_preferred;
                }.bind(this));
        },

        handleClickAddConnection: function handleClickAddConnection() {

            // Toast configuration
            var toastIcon = '<span class="icon icon-hb-nx-participants"></span>';
            var toastText = ' added successfully!';
            var toastTimeout = 1000;

            this.AnalyticsService.trackClick(this, 'network invite user to community');
            this.NetworkService.inviteUser().then(function success(user){

                this.$timeout( function () {
                    var userNameSafeString = this.UIUtils.sanitize(user.full_name);
                    this.ngToast.create({
                        content:  toastIcon + userNameSafeString + toastText,
                        className: 'success',
                        dismissOnTimeout: true,
                        dismissButton: true
                    });
                }.bind(this), toastTimeout);

                // emit name for header nav title, via network controller broadcast
                this.$scope.$emit('emitContactsAdded');
            }.bind(this));
        },

        onGoogleSyncBtnClicked: function onGoogleSyncBtnClicked() {
            //analytics move here because they need to act different, sending too many args for them to match the other "add gmail integration" events that we have.
            if (this.currNetworkUser.isGoogleIntegrationActive('contacts')){
                this.AnalyticsService.trackClick(this, 'open google contacts', {source: "second_level_nav", type: "contacts", app_path: "second_level_nav", event: "open google contacts", eventType: "click"});
            }
            else{
                this.AnalyticsService.trackClick(this, 'add gmail integration', {source: "second_level_nav", type: "contacts", app_path: "second_level_nav", event: "add gmail integration", eventType: "click"});
            }

            this.UserService.syncGoogleContactClicked();
        }
    });
}());
